import angular from "angular";

import angularStorage from "angular-storage";
import userInfoServiceModule from "./UserInfoService";

import Assert from "tbAssert";

import EventFilter from "../models/EventFilter";

const mCanStoreFilterPrefs = new WeakMap();
const mUserFilterPrefsKey = new WeakMap();

const unknownUserPrefsKey = "unknownUser1932";

const mLogSvc = new WeakMap();
const mStoreSvc = new WeakMap();
const mUserInfoSvc = new WeakMap();

const calendarEventFilterKey = "calendarFilter";
const mCalendarEventFilter = new WeakMap();

const searchEventFilterKey = "searchFilter";
const mSearchEventFilter = new WeakMap();

//class LocalStorageShim {
//    constructor() {}
//
//    set(key, value) {
//        localStorage[key] = value;
//    }
//
//    get(key) {
//        return localStorage[key];
//    }
//}

class EventFilterStoreService {
    constructor($log, store, UserInfoService) {
        Assert.StrictAssert($log != null, "Assertion Failure: Missing Log Service Dependency");
        Assert.StrictAssert(store != null, "Assertion Failure: Missing Angular Storage Service Dependency");
        Assert.StrictAssert(UserInfoService != null, "Assertion Failure: Missing User Info Service Dependency");

        mLogSvc.set(this, $log);
        mStoreSvc.set(this, store);
        mUserInfoSvc.set(this, UserInfoService);

        mCanStoreFilterPrefs.set(this, false);
        mUserFilterPrefsKey.set(this, unknownUserPrefsKey);

        this._loadPrefs();
    }

    _buildFullKey(itemKey) {
        return `${itemKey}.${mUserFilterPrefsKey.get(this)}`;
    }

    _loadPrefs() {
        let userName = mUserInfoSvc.get(this).userName;

        if (userName == null) {
            mUserFilterPrefsKey.set(this, unknownUserPrefsKey);
            mCanStoreFilterPrefs.set(this, false);
            return;
        }

        mUserFilterPrefsKey.set(this, `${userName}.filterPrefs`);
        mCanStoreFilterPrefs.set(this, true);

        let calendarEventFilterFullKey = this._buildFullKey(calendarEventFilterKey);
        let calendarEventFilterJson = mStoreSvc.get(this).get(calendarEventFilterFullKey);
        if (typeof calendarEventFilterJson === "string") {
            let calendarEventFilter = EventFilter.fromJSON(calendarEventFilterJson);
            mCalendarEventFilter.set(this, calendarEventFilter);
        }
        else {
            mCalendarEventFilter.set(this, new EventFilter({}));
            mStoreSvc.get(this).set(calendarEventFilterFullKey, mCalendarEventFilter.get(this).toJSON());
        }

        let searchEventFilterFullKey = this._buildFullKey(searchEventFilterKey);
        let searchEventFilterJson = mStoreSvc.get(this).get(searchEventFilterFullKey);
        if (typeof searchEventFilterJson === "string") {
            let searchEventFilter = EventFilter.fromJSON(searchEventFilterJson);
            mSearchEventFilter.set(this, searchEventFilter);
        }
        else {
            mSearchEventFilter.set(this, new EventFilter({}));
            mStoreSvc.get(this).set(searchEventFilterFullKey, mSearchEventFilter.get(this).toJSON());
        }
    }

    toString() {
        return `Event Filter Store||${mCalendarEventFilter.get(this)}||${mSearchEventFilter.get(this)}||`;
    }

    get calendarEventFilter() {
        return mCalendarEventFilter.get(this);
    }

    get searchEventFilter() {
        return mSearchEventFilter.get(this);
    }

    saveCalendarEventFilter() {
        if (mCanStoreFilterPrefs.get(this) === true) {
            let calendarEventFilterFullKey= this._buildFullKey(calendarEventFilterKey);
            let calendarEventFilterJson = mCalendarEventFilter.get(this).toJSON();
            mStoreSvc.get(this).set(calendarEventFilterFullKey, calendarEventFilterJson);
            mLogSvc.get(this).debug(`New Calendar Event Filter Stored: ${calendarEventFilterJson}`);
        }
        else {
            mLogSvc.get(this).debug("Could Not Store Calendar Event Filter Value.");
        }
    }

    saveSearchEventFilter() {
        if (mCanStoreFilterPrefs.get(this) === true) {
            let searchEventFilterFullKey= this._buildFullKey(searchEventFilterKey);
            let searchEventFilterJson = mSearchEventFilter.get(this).toJSON();
            mStoreSvc.get(this).set(searchEventFilterFullKey, searchEventFilterJson);
            mLogSvc.get(this).debug(`New Search Event Filter Stored: ${searchEventFilterJson}`);
        }
        else {
            mLogSvc.get(this).debug("Could Not Store Search Event Filter Value.");
        }
    }

    reload() {
        mLogSvc.get(this).debug("Reloading Event Filter Store Data.");
        this._loadPrefs();
    }
}

EventFilterStoreService.$inject = [ "$log", "store", "UserInfoService" ];

export default angular
    .module("trackerbase-app.services.event-filter-store-service", [
        angularStorage,
        userInfoServiceModule
    ])
    .service("EventFilterStore", EventFilterStoreService)
    .name;



//////////////////
// WEBPACK FOOTER
// ./src/services/EventFilterStoreService.js
// module id = clgK
// module chunks = 1